export default __webpack_public_path__ + "static/media/PowerSlugGreen.256.63d17f7d.png";